import React, { useContext } from 'react';

import _ from 'lodash';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

import { Icon as MDIcon } from '@mdi/react';
import * as allIcons from '@mdi/js';

import { withTheme } from '@material-ui/core/styles';

import LocalizationContext from 'utils/contexts/LocalizationContext';
import { loc } from 'localizations/localizationHandler';

import ConfirmDialogContext from 'components/Dialogs/Confirm/ConfirmDialogContext';

function ImageScroll(props) {
    const {
        theme,
        displayImageIdx,
        disableDelete,
        displayImages,
        onImageDelete,
        onImageSelect,
        showDeleteButton = false,
        scrollerStyles = {},
        imageIcons = [],
        imageIconSize = 1,
        blockStyles = {}
    } = props;

    return (
        <div
            style={{
                // margin: theme.spacing.unit / 2,
                padding: 6,
                display: 'flex',
                ...scrollerStyles
            }}
        >
            {displayImages.map((displayImage, idx) => {
                return (
                    <ImageBlock
                        theme={theme}
                        selected={displayImageIdx === idx}
                        disableDelete={disableDelete}
                        displayImage={displayImage}
                        onImageSelect={() => onImageSelect(idx)}
                        onImageDelete={() => onImageDelete(idx)}
                        showDeleteButton={showDeleteButton}
                        icon={_.get(imageIcons, `[${idx}]`)}
                        imageIconSize={imageIconSize}
                        style={blockStyles}
                    />
                );
            })}
        </div>
    );
}
export default withTheme()(ImageScroll);

export function ImageBlock(props) {
    const { lang } = useContext(LocalizationContext);
    const warnAction = useContext(ConfirmDialogContext);

    const {
        theme,
        selected,
        displayImage,
        disableDelete,
        icon,
        onImageSelect,
        onImageDelete,
        showDeleteButton,
        style,
        imageIconSize
    } = props;

    const iconName = _.get(icon, 'name');
    const iconColor = _.get(icon, 'color');

    return (
        <div style={{ margin: theme.spacing.unit / 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div
                style={{
                    borderStyle: selected ? 'ridge' : null,
                    borderRadius: theme.spacing.unit / 2,
                    minWidth: 64,
                    minHeight: 64,
                    maxWidth: 64,
                    maxHeight: 64,
                    textAlign: 'center',
                    backgroundImage: `url(${displayImage})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative',
                    cursor: 'pointer',
                    ...style
                }}
                onClick={onImageSelect}
            >
                {!_.isNil(icon) && (
                    <div style={{ position: 'absolute', top: -6, right: -6 }}>
                        <IconButton style={{ padding: 1, margin: 0, backgroundColor: 'white' }}>
                            <MDIcon path={_.get(allIcons, iconName)} size={imageIconSize} color={iconColor} />
                        </IconButton>
                    </div>
                )}
            </div>
            {showDeleteButton && !disableDelete && (
                <Button
                    size="small"
                    style={{ minWidth: 0, minHeight: 0, padding: '3px 6px', fontSize: 12, marginTop: 2 }}
                    onClick={() => warnAction(() => onImageDelete(), loc('delete_image', lang))}
                >
                    Retake
                </Button>
            )}
        </div>
    );
}
